export const LOADING = "home/loading";
export const POPULATE_LIST = "home/populate-list";
export const SUCCESS_LOADING = "home/success-loading";
export const FAILED_LOADING = "home/failed-loading";
export const VALUE = "home/value";
